/**
 * @fileoverview gRPC-Web generated client stub for mlmbox.client.account.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.15.8
// source: mlmbox/client/account/v1/account.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var mlmbox_type_account_pb = require('../../../../mlmbox/type/account_pb.js')

var mlmbox_type_confirmation_pb = require('../../../../mlmbox/type/confirmation_pb.js')

var mlmbox_type_locale_pb = require('../../../../mlmbox/type/locale_pb.js')

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')
const proto = {};
proto.mlmbox = {};
proto.mlmbox.client = {};
proto.mlmbox.client.account = {};
proto.mlmbox.client.account.v1 = require('./account_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.account.v1.AccountClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.mlmbox.client.account.v1.AccountPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.mlmbox.type.Account>}
 */
const methodDescriptor_Account_Info = new grpc.web.MethodDescriptor(
  '/mlmbox.client.account.v1.Account/Info',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  mlmbox_type_account_pb.Account,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_account_pb.Account.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Account)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Account>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.account.v1.AccountClient.prototype.info =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/Info',
      request,
      metadata || {},
      methodDescriptor_Account_Info,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Account>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.account.v1.AccountPromiseClient.prototype.info =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/Info',
      request,
      metadata || {},
      methodDescriptor_Account_Info);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.account.v1.AccountPasswordSetRequest,
 *   !proto.mlmbox.type.Confirmation>}
 */
const methodDescriptor_Account_PasswordSet = new grpc.web.MethodDescriptor(
  '/mlmbox.client.account.v1.Account/PasswordSet',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.account.v1.AccountPasswordSetRequest,
  mlmbox_type_confirmation_pb.Confirmation,
  /**
   * @param {!proto.mlmbox.client.account.v1.AccountPasswordSetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.account.v1.AccountPasswordSetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.account.v1.AccountClient.prototype.passwordSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/PasswordSet',
      request,
      metadata || {},
      methodDescriptor_Account_PasswordSet,
      callback);
};


/**
 * @param {!proto.mlmbox.client.account.v1.AccountPasswordSetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.account.v1.AccountPromiseClient.prototype.passwordSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/PasswordSet',
      request,
      metadata || {},
      methodDescriptor_Account_PasswordSet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.client.account.v1.AccountEmailSetRequest,
 *   !proto.mlmbox.type.Confirmation>}
 */
const methodDescriptor_Account_EmailSet = new grpc.web.MethodDescriptor(
  '/mlmbox.client.account.v1.Account/EmailSet',
  grpc.web.MethodType.UNARY,
  proto.mlmbox.client.account.v1.AccountEmailSetRequest,
  mlmbox_type_confirmation_pb.Confirmation,
  /**
   * @param {!proto.mlmbox.client.account.v1.AccountEmailSetRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  mlmbox_type_confirmation_pb.Confirmation.deserializeBinary
);


/**
 * @param {!proto.mlmbox.client.account.v1.AccountEmailSetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.mlmbox.type.Confirmation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.mlmbox.type.Confirmation>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.account.v1.AccountClient.prototype.emailSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/EmailSet',
      request,
      metadata || {},
      methodDescriptor_Account_EmailSet,
      callback);
};


/**
 * @param {!proto.mlmbox.client.account.v1.AccountEmailSetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.mlmbox.type.Confirmation>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.account.v1.AccountPromiseClient.prototype.emailSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/EmailSet',
      request,
      metadata || {},
      methodDescriptor_Account_EmailSet);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.mlmbox.type.Locale.ID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_Account_LocaleSet = new grpc.web.MethodDescriptor(
  '/mlmbox.client.account.v1.Account/LocaleSet',
  grpc.web.MethodType.UNARY,
  mlmbox_type_locale_pb.Locale.ID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.mlmbox.type.Locale.ID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.mlmbox.type.Locale.ID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.mlmbox.client.account.v1.AccountClient.prototype.localeSet =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/LocaleSet',
      request,
      metadata || {},
      methodDescriptor_Account_LocaleSet,
      callback);
};


/**
 * @param {!proto.mlmbox.type.Locale.ID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.mlmbox.client.account.v1.AccountPromiseClient.prototype.localeSet =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/mlmbox.client.account.v1.Account/LocaleSet',
      request,
      metadata || {},
      methodDescriptor_Account_LocaleSet);
};


module.exports = proto.mlmbox.client.account.v1;

